module.exports = __webpack_public_path__ + "static/img/8.721ae10.png";


//////////////////
// WEBPACK FOOTER
// ./static/hz/8.png
// module id = qSsq
// module chunks = 202